import { getAuth } from 'firebase/auth';
import { serverTimestamp, Timestamp } from 'firebase/firestore';

import { IEventAtRead, IEventAtWrite } from '@ld/utils';

const getEventAt = (): { write: IEventAtWrite; read: IEventAtRead } => {
  const user = getAuth().currentUser;
  if (!user) {
    throw new Error('User is not authenticated');
  }
  const base = {
    uid: user.uid,
    name: user.displayName || ''
  };
  return {
    write: { ...base, timestamp: serverTimestamp() },
    read: { ...base, timestamp: Timestamp.fromDate(new Date()) }
  };
};

export default getEventAt;
